module.exports = __webpack_public_path__ + "static/media/one_clinics.3acef376.webp";